import React from 'react';

export const PULL_TIME = 500;
export const LOADING_CHECK_FREQUENCY = 750;
// 5s
export const MESSAGE_DEFAULT_CLOSE_TIME = 5 * 1000;
export const DESTINATION_SENDER_ERROR = '"To Address" can not be the sending address';
export const COINMARKETCAP_ENDPOINT = 'https://api.coinmarketcap.com/v2/ticker';
export const COINMARKETCAP_ETH_ID = 1027;
export const COINMARKETCAP_CAT_ID = 1882;
export const CURRENCY_CODES = ['usd', 'aud', 'cad', 'cny', 'eur', 'gbp', 'jpy'];
// 5 min.
export const EXCHANGE_RATE_REFRESH_INTERVAL = 1000 * 60 * 5;

export const ETH_GAS_PRICE_ENDPOINT = 'https://ethgasstation.info/json/ethgasAPI.json';

export const ActionStatusEnum = Object.freeze({
  processing: -1,
  cancelled: 0,
  pending: 1,
  accepted: 2,
  failed: 1337,
});

export const PaymentStatus = Object.freeze({
  draft: 'draft',
  sending: 'sending',
  confirmingSend: 'confirming',
  failed: 'failed',
  pending: 'pending',
  accepting: 'accepting',
  confirmingAccept: 'confirming accept',
  accepted: 'accepted',
  cancelling: 'cancelling',
  confirmingCancel: 'confirming cancel',
  cancelled: 'cancelled',
});

export const statusMapping = {
  [ActionStatusEnum.processing]: PaymentStatus.confirmingSend,
  [ActionStatusEnum.cancelled]: PaymentStatus.cancelled,
  [ActionStatusEnum.pending]: PaymentStatus.pending,
  [ActionStatusEnum.accepted]: PaymentStatus.accepted,
  [ActionStatusEnum.failed]: PaymentStatus.failed,
};

export const SUPPORT_LINK = 'mailto:support@blockcat.io';
export const TERMS_OF_SERVICE_URL = '/Tabby_Pay_Terms_of_Service.pdf';
export const TABBY_HOME_PAGE_URL = 'https://tabby.io/';
export const GAS_GUIDE_URL = 'https://media.consensys.net/a-guide-to-gas-12b40d03605d';

export const TRACKER_TYPES = Object.freeze({
  event: 'event',
});
export const EVENT_TRACKER_LABELS = Object.freeze({
  click: 'click',
});

// Documentation for EVENT_TRACKER_ACTIONS:

// cancelButtonClicked: "user clicked cancel on a payment"
// handleCancel: "user clicked continue (to cancel) on a payment"
// cancelPaymentFail: "user rejected from metamask"
// cancelPaymentSuccess: "user successfully cancelled"

// acceptButtonClicked: "user clicked accept on a payment"
// handleAccept: "user clicked continue (to accept) on a payment"
// acceptPaymentFail: "user rejected from metamask"
// acceptPaymentSuccess: "user successfully accepted"

// paymentSendButtonClicked: "user clicked the continue button to create/send payment"
// paymentSendValidationError: "after user clicked send, there were validation errors"
// paymentSendContinueButtonClicked: "user clicked continue (to create/send) a payment"
// paymentSendBackButtonClicked: "user clicked continue (to create/send) a payment"
// paymentSendSuccess: "payment successfully created"
// paymentSendFail: "user rejected from metamask"

export const EVENT_TRACKER_ACTIONS = Object.freeze({
  cancelButtonClicked: 'cancelButtonClicked',
  handleCancel: 'handleCancel',
  cancelPaymentFail: 'cancelPaymentFail',
  cancelPaymentSuccess: 'cancelPaymentSuccess',

  acceptButtonClicked: 'acceptButtonClicked',
  handleAccept: 'handleAccept',
  acceptPaymentFail: 'acceptPaymentFail',
  acceptPaymentSuccess: 'acceptPaymentSuccess',

  paymentSendButtonClicked: 'paymentSendButtonClicked',
  paymentSendValidationError: 'paymentSendValidationError',
  paymentSendContinueButtonClicked: 'paymentSendContinueButtonClicked',
  paymentSendBackButtonClicked: 'paymentSendBackButtonClicked:',
  paymentSendSuccess: 'paymentSendSuccess',
  paymentSendFail: 'paymentSendFail',
});

// Mapping network IDs to names from https://github.com/ethereum/EIPs/blob/master/EIPS/eip-155.md.
export const NETWORK_NAMES = Object.freeze({
  1: 'Ethereum Mainnet',
  2: 'Expanse Mainnet',
  3: 'Ropsten',
  4: 'Rinkeby',
  30: 'Rootstock Mainnet',
  31: 'Rootstock testnet',
  42: 'Kovan',
  61: 'Ethereum Classic Mainnet',
  62: 'Ethereum Classic testnet',
  1337: 'Geth Private chain',
  default: 'Unknown',
});

// in gwei
export const BACKUP_GAS_PRICE = 41;

export const MAX_TOKENS_TO_SEND = '1000000000';

export const ADDRESS_CHECKSUM_WARNING = (
  <span>
    This isn&apos;t checksummed. We recommend using{' '}
    <a
      href="https://github.com/ethereum/EIPs/blob/master/EIPS/eip-55.md"
      target="_blank"
      rel="noopener noreferrer"
    >
      checksummed addresses
    </a>{' '}
    to help prevent sending to the wrong address.
  </span>
);
export const BALANCE_ALLOWANCE_POLL_FREQUENCY = 1000;

export const APP_NAME = 'Tabby Pay';



// WEBPACK FOOTER //
// ./src/constants.js